import { Component, inject, OnDestroy, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import { Subject, takeUntil } from 'rxjs';
import { CoaterLicense } from '@workspace-app/odatabackend/QualicoatBackendModel';
import { LicenseViewComponent } from './license-view.component';
import { AutoCloseOverlayMixin } from '../../../../shared/mixins/auto-close-overlay.mixin';
import { LicensesService } from '../../services/licenses.service';

@Component({
  selector: 'app-license-overlay',
  imports: [LicenseViewComponent],
  template: `
    @if (license()) {
      <app-license-view [license]="license()!" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [],
})
export class LicenseOverlayComponent extends AutoCloseOverlayMixin implements OnInit, OnDestroy {
  private config = inject(DynamicDialogConfig);
  private licensesService = inject(LicensesService);

  license = signal<CoaterLicense | undefined>(undefined);
  private closeSubscription$ = new Subject<void>();

  constructor() {
    super();
    this.license.set(this.config.data.license);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    // Subscribe to close dialog events
    this.licensesService.closeDialogs.pipe(takeUntil(this.closeSubscription$)).subscribe(() => this.dialogRef.close());

    // Subscribe to license updates to refresh the dialog when license is modified
    this.licensesService.licenseUpdated.pipe(takeUntil(this.closeSubscription$)).subscribe((updatedLicense) => {
      const currentLicense = this.license();
      if (currentLicense && updatedLicense.id === currentLicense.id) {
        this.license.set(updatedLicense);
      }
    });
  }

  override ngOnDestroy(): void {
    this.closeSubscription$.next();
    this.closeSubscription$.complete();
    super.ngOnDestroy();
  }
}
